/*
 * @Author: lixin jiang
 * @Date: 2021-07-15 13:00:34
 * @LastEditTime: 2021-12-06 09:57:55
 * @LastEditors: Kun Yang
 * @Description:
 * @FilePath: /aid-base/src/index.js
 * @
 */
import AidRectCheckbox from './components/AidRectCheckbox';
import ArcButton from './components/ArcButton';
import ArcInput from './components/ArcInput';
import ColorChoice from './components/ColorChoice';
import Demo from './components/Demo';
import GroupButton from './components/GroupButton';
import GroupRectCheckbox from './components/GroupRectCheckbox';
import Tabs from './components/Tabs';
import Modal from './components/Modal';
import PriceTag from './components/PriceTag';
import ProductTypeTag from './components/ProductTypeTag';

export {
  ArcInput,
  ArcButton,
  AidRectCheckbox,
  ColorChoice,
  GroupButton,
  GroupRectCheckbox,
  Tabs,
  Demo,
  Modal,
  PriceTag,
  ProductTypeTag,
};

export default {
  ArcInput,
  ArcButton,
  AidRectCheckbox,
  ColorChoice,
  GroupButton,
  GroupRectCheckbox,
  Tabs,
  Modal,
  PriceTag,
  ProductTypeTag,
};
